/* 
 * 维护一个 eventList 用来非父子组件交互
 */

class EventEmitter {
    constructor() {
        this.eventList = {}
        this.eventListener = {}
    }

    set(key, value) {
        this.eventList[key] = value
        if (this.eventListener[key]) {
            this.eventListener[key].map(item => item && item(value))
        }
    }

    subscribe(key, fn) {
        if (!this.eventListener[key]) this.eventListener[key] = []
        this.eventListener[key].push(fn)
    }
}

const eventEmitter = new EventEmitter()

export default eventEmitter